export default __webpack_public_path__ + "static/media/user-circle.64a11108.svg";